
import { Influencer } from "@/types/influencer";
import { InfluencerCard } from "./InfluencerCard";
import { motion } from "framer-motion";

interface InfluencerGridProps {
  influencers: Influencer[];
}

export const InfluencerGrid = ({ influencers }: InfluencerGridProps) => {
  const noInfluencers = influencers.length === 0;
  
  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <motion.div
      variants={container}
      initial="hidden"
      animate="show"
      className="relative"
    >
      {noInfluencers ? (
        <motion.div 
          className="text-center py-16 px-4 rounded-xl border border-primary/10 bg-primary/5"
          variants={item}
        >
          <p className="text-lg text-muted-foreground">No influencers found matching your criteria.</p>
        </motion.div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {influencers.map((influencer) => (
            <motion.div key={influencer.id} variants={item}>
              <InfluencerCard influencer={influencer} />
            </motion.div>
          ))}
        </div>
      )}
    </motion.div>
  );
};
